import { render, staticRenderFns } from "./inputRadio.vue?vue&type=template&id=67a91c0d&"
import script from "./inputRadio.vue?vue&type=script&lang=js&"
export * from "./inputRadio.vue?vue&type=script&lang=js&"
import style0 from "./inputRadio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports